import { SignalsPayload } from "@timeedit/registration-schemas";
import { isDefined } from "@timeedit/registration-shared";
import { Layout } from "@timeedit/ui-components/antd";
import { Fragment, useContext, useMemo } from "react";
import { CourseList } from "./CourseList";
import { GroupPage } from "./GroupPage/GroupPage";
import { IdContext } from "./RegistrationContexts";
import { RegistrationHeader } from "./RegistrationHeader";
import "./registrationPage.scss";

interface RegistrationMobileProps {
  signal?: SignalsPayload;
  isHub?: boolean;
}
export function RegistrationMobile({
  signal,
  isHub,
}: RegistrationMobileProps): React.JSX.Element {
  const { id } = useContext(IdContext);

  const showOutlet = useMemo(() => {
    return !!id;
  }, [id]);

  if (showOutlet) return <GroupPage />;
  const Wrapper = isHub ? Fragment : Layout;

  return (
    <Wrapper>
      {!isHub && isDefined(signal) && <RegistrationHeader signal={signal} />}
      <div className="registration-page__content">
        <section className="registration-page__course-activities">
          <CourseList />
        </section>
      </div>
    </Wrapper>
  );
}
